import { DS } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'
import { Types, Disciplines, QuickLinks } from '.'

export const DSLog = new CIMSPageItem({
  id: 'db9a46de-2789-47c3-84fb-87d83c22cd88',
  name: 'Design Submittal Log',
  pathname: 'log',
  module: DS,
  linkable: true,
})
export const DSTypes = Types({
  id: 'fc29e8b0-1b1c-4668-bb0b-42beceb29332',
  module: DS,
})
export const DSOrganizations = new CIMSPageItem({
  id: '776fc2bc-794c-43f2-8eae-12de8b6dcb07',
  name: 'Organizations',
  pathname: 'organizations',
  module: DS,
})
export const DSDisciplines = Disciplines({
  id: '55dd01dc-bd40-48cb-acac-b36c44d76477',
  module: DS,
})
export const DSActions = new CIMSPageItem({
  id: '0fa370d1-7abe-4c8b-9308-afb76e3451f5',
  name: 'Actions',
  pathname: 'actions',
  module: DS,
})
export const DSQuickLinks = QuickLinks({
  id: '5dd651d7-3171-45ae-a46e-510c158db927',
  module: DS,
})
export const DSNotifications = new CIMSPageItem({
  id: '5aff29b7-ea67-419b-925d-7b58a2385222',
  name: 'Notifications',
  pathname: 'notifications',
  module: DS,
})
export type DSPageItem =
  | typeof DSLog
  | typeof DSTypes
  | typeof DSOrganizations
  | typeof DSDisciplines
  | typeof DSActions
  | typeof DSQuickLinks
  | typeof DSNotifications
